* {
  box-sizing: border-box;
}
:host {
  height: auto;
  --table-font-size: var(--body-size);
}

:host([classicTableStyle]) {
  table {
    th {
      span {
        font-weight: 700;
      }
    }
    tr {
      td {
        &.value {
          font-weight: 400;
        }
      }
    }
  }
}

table {
  border-collapse: collapse;
  font-size: var(--table-font-size);
  color: var(--body-text-arrows-400);
  table-layout: auto;
  width: 100%;
  tr {
    &:not(:last-child) {
      border-bottom: 1px solid var(--chart-101-pressed-dividers);
    }

    td {
      padding: var(--spacer) calc(var(--spacer) * 3) var(--spacer) 0;

      &.label {
        padding-right: calc(var(--spacer) * 2);
      }

      &.value {
        font-weight: 700;
      }
    }
  }
  th {
    text-align: left;
    font-weight: 100;
    padding: var(--spacer) 0 var(--spacer) 0;

    .label-container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-right: calc(var(--spacer) * 3);

      span {
        width: calc(var(--spacer) + 2px);
        height: calc(var(--spacer) + 2px);
        margin-right: var(--spacer);
        display: inline-block;
      }
      .header-text-visible {
        width: auto;
        line-height: 10px;
      }
      .header-text-hidden {
        display: none;
      }
    }
  }
}
